
export const TOGGLE_DARKTHEME = "TOGGLE_DARKTHEME";

export const toggleDarkTheme = () => ({
  type: TOGGLE_DARKTHEME,
});